// extracted by mini-css-extract-plugin
export default {"container":"Title_container__SEI+u","title":"Title_title__MN903","animated":"Title_animated__uhGBh","seeButton":"Title_seeButton__cCG-V"};